//==============================================================================
/**
 * Available statuses for gyroscope permissions
 * @type {object} pseudo-constant
 */
const PermissionStatuses =
  {
    UNKNOWN     : "unknown",
    GRANTED     : "granted",
    DENIED      : "denied"
  };

export { PermissionStatuses };